import BackupSchedule, { BackupScheduleType } from '../../types/BackupSchedule';
import { Button, ButtonProps } from 'antd';
import {
    PauseCircleOutlined,
    PlayCircleOutlined,
} from '@severalnines/frontend_hub/libs/icons';
import {
    backupSettingsApiInterface,
    BackupSettingsPatchDTO,
} from '../../sdk/BackupsApi';
import DeploymentsItem from '../../types/DeploymentsItem';
import StretchedClick from '../common/StretchedClick';
import { Draft } from '@reduxjs/toolkit';

type BackupsScheduleBinlogSwitchButtonProps = ButtonProps & {
    deployment: Draft<DeploymentsItem>;
    schedule: BackupSchedule;
    onSuccess?: () => void;
    stretchedClick?: boolean;
};
export default function BackupsScheduleBinlogSwitchButton({
    deployment,
    schedule,
    onSuccess,
    stretchedClick = false,
    ...rest
}: BackupsScheduleBinlogSwitchButtonProps) {
    const applyEnabled = async (enabled: boolean) => {
        try {
            let settings = {
                binlog: {
                    enabled,
                },
            };
            await backupSettingsApiInterface.settingsDatastoreUuidPatch(
                deployment.dataStoreUuid,
                settings
            );
            onSuccess?.();
        } catch (e: any) {
            console.error(e);
        }
    };
    const handlePause = async () => {
        try {
            await applyEnabled(false);
        } catch (e: any) {
            console.error(e);
        }
    };

    const handleEnable = async () => {
        try {
            await applyEnabled(true);
        } catch (e: any) {
            console.error(e);
        }
    };
    return schedule.isActive() ? (
        <>
            {stretchedClick && <StretchedClick handleClick={handlePause} />}
            <Button
                onClick={() => {
                    if (stretchedClick) return;
                    handlePause();
                }}
                icon={<PauseCircleOutlined />}
                type={'text'}
            >
                Pause
            </Button>
        </>
    ) : (
        <>
            {stretchedClick && <StretchedClick handleClick={handleEnable} />}

            <Button
                onClick={() => {
                    if (stretchedClick) return;
                    handleEnable();
                }}
                icon={<PlayCircleOutlined />}
                type={'text'}
            >
                Enable
            </Button>
        </>
    );
}
